import React from 'react';
import { ClassNameMap } from '@material-ui/styles';
import { MenuItem, Select, Tooltip } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { SelectItem } from '../types/locationTypes'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

interface PlannerSelectProps {
    parentClasses: ClassNameMap,
    listValues: SelectItem[],
    setValue: any,
    value: string,
    labelText: string,
    lastElement?: boolean,
    description: string,
    readonly:boolean,
}

const PlannerSelect: React.FC<PlannerSelectProps> = ({
    parentClasses,
    listValues,
    setValue,
    value,
    labelText,
    lastElement,
    description,
    readonly
}) => {

    return (
        <div className={parentClasses.inputRow} style={lastElement ? {
            borderBottomRightRadius: 4
        } : {}}>
            <div className={parentClasses.labelText}>
                {labelText}
                <span>
                    <Tooltip title={description}>
                        <InfoOutlinedIcon className={parentClasses.labelIcon} />
                    </Tooltip>
                </span>
            </div>
            <Select
                onChange={e => setValue(e.target.value)}
                className={parentClasses.selectField}

                fullWidth={true}
                value={value}
                IconComponent={KeyboardArrowDownIcon}
                displayEmpty
                defaultValue=''
               disabled={readonly}
                variant="outlined">
                {
                    listValues.map(
                        item =>
                            <MenuItem
                                disabled={item.disabled}
                                selected={item.selected}
                                key={item.value}
                                defaultValue={item.value}
                                value={item.value}>
                                {item.text}
                            </MenuItem>
                    )
                }
            </Select>
        </div>
    );
}

export default PlannerSelect;